module.exports = __webpack_public_path__ + "img/logo.1fde98af.png";